import { render, staticRenderFns } from "./superAdminInfo.vue?vue&type=template&id=3798f058&scoped=true&"
import script from "./superAdminInfo.vue?vue&type=script&lang=js&"
export * from "./superAdminInfo.vue?vue&type=script&lang=js&"
import style0 from "./superAdminInfo.vue?vue&type=style&index=0&id=3798f058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3798f058",
  null
  
)

export default component.exports